import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { OctagonAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { Toast } from '@/common/components/Toast'
import { PostModel } from '@/common/models/post'
import { api, ApiError, APIPaginated } from '@/lib/axios'
import { useNewsHighlighted } from './useNewsHighlighted'

async function getPaginateInactiveNewsHighlighted() {
  const { data } = await api.backend.get<APIPaginated<PostModel>>(
    '/posts/paginate',
    {
      params: {
        limit: 10,
        relations: {
          where: {
            isSlider: true,
            isActive: true,
            sliderSort: {
              lte: -1,
            },
          },
          orderBy: [{ sliderSort: 'asc' }, { createdAt: 'desc' }],
        },
      },
    },
  )

  return data
}

export function useManageHighlightedNews() {
  const { newsHighlighted, isLoadingNewsHighlighted } = useNewsHighlighted()
  const { t } = useTranslation('panel')

  const { data, isLoading, error } = useQuery<
    APIPaginated<PostModel>,
    AxiosError<ApiError>
  >({
    queryKey: ['/posts-slider-inactive/paginate'],
    queryFn: getPaginateInactiveNewsHighlighted,
  })

  useEffect(() => {
    if (error) {
      toast(Toast, {
        data: {
          type: 'danger',
          icon: OctagonAlert,
          title: t('news.use_manage_highlighted_news.toast_error.title'),
          description:
            error?.response?.data?.friendlyMessage ||
            t('news.use_manage_highlighted_news.toast_error.description'),
        },
      })
    }
  }, [error, t])

  return {
    activeNewsHighlighted: newsHighlighted,
    inactiveNewsHighlighted: data?.items || [],
    isLoadingInactiveNewsHighlighted: isLoading,
    isLoadingActiveNewsHighlighted: isLoadingNewsHighlighted,
  }
}
